// Polyfills for browser compatibility
import { Buffer } from 'buffer';

// Make Buffer available globally
if (typeof window !== 'undefined') {
  (window as any).Buffer = Buffer;
}

// Polyfill for util module
if (typeof window !== 'undefined') {
  (window as any).util = {
    debuglog: () => () => {},
    inspect: (obj: any) => JSON.stringify(obj, null, 2),
  };
}

export {}; 